<template>
  <div class="main">
    <!-- <div class=" row no-gutter pl-bg pl-bg--gray-lightest pl-relative pl-spacer--cut-bottom pl-spacer--cut-v">
      <div class="col-xs-12 col-md-12 col-lg-6 col-xl-8 pl-relative ">
        <img v-bind:src="getImagePath(content.banner_img)"
             v-bind:alt="content.banner_alt"
             class="pl-amplience__image" />
      </div>

      <div class="col-xs-12 col-md-10 col-lg-6 col-xl-4 pl-relative pl-fix pl-fix--tablet--vertical pl-fix--tablet--vertical--lfts pl-fix--desktop--vertical pl-fix--desktop--right pl-bg pl-bg--gray-lightest">
        <img alt="alt text goes here"
             src="../assets/FFP/images/blank-rect.png"
             class="hidden-sm-down" />
        <div class="text-left pl-spacer pl-spacer--in--smaller pl-fix pl-fix--tablet--top pl-fix--desktop--vertical">
          <h1 class="pl-h1 pl-h1--lfts pl-h1--hero-header pl-color pl-color--gray-darkest">
            {{ content.banner_title }}
          </h1>
          <p class="pl-color pl-color--gray-darker">{{ content.banner_texts}}</p>
          <p v-for="(banner_link, index) in content.banner_links"
             v-bind:key="index">
            <a v-bind:href="banner_link.url"
               class="pl-link pl-link--animated pl-link--animated--fwd pl-link--animated--fwd--circle"
               target="_self"
               data-Tealiumevent="Generic Link (default)"
               data-Tealiumeventmetadata="Learn more here">{{ banner_link.title }}<i aria-hidden='true'></i></a>
          </p>
        </div>
      </div>
    </div> -->

    <div class='swiper_div'>
      <swiper :options="swiperOption"
              ref="banner_img"
              style="margin-bottom: 1rem;">
        <swiper-slide v-for="(item,index) in content.banner_img"
                      :key="'banner_img-'+index">
          <div class='img_div'>
            <a :href="item.banner_link">
              <picture>
                <source class='swiper_img'
                        media="(max-width: 488px)"
                        :srcset="getImagePath(item.phone_banner_img)">
                <img class='swiper_img'
                     :src="getImagePath(item.banner_img)"
                     alt="banner_img" />
              </picture>
            </a>
          </div>
        </swiper-slide>
        <div class="swiper-pagination"
             slot="pagination"></div>
      </swiper>
    </div>

    <!-- <section class="pl-spacer pl-spacer--out--large pl-spacer--cut-h">
      <h2 class="text-center pl-h2 pl-push pl-push--mobile--smaller pl-push--tablet--smaller pl-push--desktop--smaller">最新资讯</h2>
      <div class="container">
        <div id="pl-homepage-content"
             class="pl-tabs">
          <div class="pl-tabs__wrap"></div>
          <div class="row">
            <div id="featured"
                 class="pl-tabs__tab active">
              <div class="grid_show">
                <div style="padding:0 30px"
                     v-for="(home_article, index) in content.articles"
                     v-bind:key="index"
                     class="col-xs-12 col-md-3 grid-item pl-push pl-push--mobile--smaller pl-push--tablet--smaller pl-push--desktop--smaller">
                  <article>
                    <div class="pl-push pl-push--mobile--smallest pl-push--tablet--smallest pl-push--desktop--smallest pl-relative">
                      <a class="pl-amplience--overflow"
                         v-bind:href="home_article.url"
                         target="_self"
                         data-Tealiumevent="generic">
                        <picture class="pl-amplience pl-amplience--scale">
                          <img v-bind:src="getImagePath(home_article.image)"
                               v-bind:alt="home_article.alt"
                               class="pl-amplience__image" />
                        </picture>
                      </a>
                      <div class="pl-spacer pl-spacer--in--smallest pl-fix pl-fix--mobile--top-right pl-fix--tablet--top-right pl-fix--desktop--top-right">
                      </div>
                    </div>

                    <div class="pl-lockup text-left">
                      <p class="pl-tag pl-tag--gray">{{ home_article.category }}</p>
                      <h4 class="pl-h4 pl-color pl-color--gray-darker">
                        <a v-bind:href="home_article.url"
                           target="_self">{{ home_article.title }}</a>
                      </h4>
                      <p class="pl-text pl-text--small pl-color pl-color--gray-dark">{{ home_article.subtitle }}</p>
                    </div>
                  </article>
                </div>
              </div>

              <div class="grid width_50">
                <div style="padding:0 15px"
                     v-for="(home_article, index) in this.firstColumContent"
                     v-bind:key="index"
                     :class="index==0? 'width_100':(index==3? 'width_100':'width_50')"
                     class="col-xs-12 col-md-3 grid-item pl-push pl-push--mobile--smaller pl-push--tablet--smaller pl-push--desktop--smaller">
                  <article>
                    <div class="pl-push pl-push--mobile--smallest pl-push--tablet--smallest pl-push--desktop--smallest pl-relative">
                      <a class="pl-amplience--overflow"
                         v-bind:href="home_article.url"
                         target="_self"
                         data-Tealiumevent="generic">
                        <picture class="pl-amplience pl-amplience--scale">
                          <img v-bind:src="getImagePath(home_article.image)"
                               v-bind:alt="home_article.alt"
                               class="pl-amplience__image" />
                        </picture>
                      </a>
                      <div class="pl-spacer pl-spacer--in--smallest pl-fix pl-fix--mobile--top-right pl-fix--tablet--top-right pl-fix--desktop--top-right">
                      </div>
                    </div>

                    <div class="pl-lockup text-left">
                      <p class="pl-tag pl-tag--gray">{{ home_article.category }}</p>
                      <h4 class="pl-h4 pl-color pl-color--gray-darker">
                        <a v-bind:href="home_article.url"
                           target="_self">{{ home_article.title }}</a>
                      </h4>
                      <p class="pl-text pl-text--small pl-color pl-color--gray-dark">{{ home_article.subtitle }}</p>
                    </div>
                  </article>
                </div>
              </div>

              <div class="grid width_50">
                <div class="width_50 float_left">
                  <div style="padding:0 15px"
                       v-for="(home_article, index) in this.secondColumContent"
                       v-bind:key="index"
                       class="width_100 col-xs-12 col-md-3 grid-item pl-push pl-push--mobile--smaller pl-push--tablet--smaller pl-push--desktop--smaller">
                    <article>
                      <div class="pl-push pl-push--mobile--smallest pl-push--tablet--smallest pl-push--desktop--smallest pl-relative">
                        <a class="pl-amplience--overflow"
                           v-bind:href="home_article.url"
                           target="_self"
                           data-Tealiumevent="generic">
                          <picture class="pl-amplience pl-amplience--scale">
                            <img v-bind:src="getImagePath(home_article.image)"
                                 v-bind:alt="home_article.alt"
                                 class="pl-amplience__image" />
                          </picture>
                        </a>
                        <div class="pl-spacer pl-spacer--in--smallest pl-fix pl-fix--mobile--top-right pl-fix--tablet--top-right pl-fix--desktop--top-right">
                        </div>
                      </div>

                      <div class="pl-lockup text-left">
                        <p class="pl-tag pl-tag--gray">{{ home_article.category }}</p>
                        <h4 class="pl-h4 pl-color pl-color--gray-darker">
                          <a v-bind:href="home_article.url"
                             target="_self">{{ home_article.title }}</a>
                        </h4>
                        <p class="pl-text pl-text--small pl-color pl-color--gray-dark">{{ home_article.subtitle }}</p>
                      </div>
                    </article>
                  </div>
                </div>
                <div class="width_50 float_left">
                  <div style="padding:0 15px"
                       v-for="(home_article, index) in this.thirdColumContent"
                       v-bind:key="index"
                       class="width_100 col-xs-12 col-md-3 grid-item pl-push pl-push--mobile--smaller pl-push--tablet--smaller pl-push--desktop--smaller">
                    <article>
                      <div class="pl-push pl-push--mobile--smallest pl-push--tablet--smallest pl-push--desktop--smallest pl-relative">
                        <a class="pl-amplience--overflow"
                           v-bind:href="home_article.url"
                           target="_self"
                           data-Tealiumevent="generic">
                          <picture class="pl-amplience pl-amplience--scale">
                            <img v-bind:src="getImagePath(home_article.image)"
                                 v-bind:alt="home_article.alt"
                                 class="pl-amplience__image" />
                          </picture>
                        </a>
                        <div class="pl-spacer pl-spacer--in--smallest pl-fix pl-fix--mobile--top-right pl-fix--tablet--top-right pl-fix--desktop--top-right">
                        </div>
                      </div>

                      <div class="pl-lockup text-left">
                        <p class="pl-tag pl-tag--gray">{{ home_article.category }}</p>
                        <h4 class="pl-h4 pl-color pl-color--gray-darker">
                          <a v-bind:href="home_article.url"
                             target="_self">{{ home_article.title }}</a>
                        </h4>
                        <p class="pl-text pl-text--small pl-color pl-color--gray-dark">{{ home_article.subtitle }}</p>
                      </div>
                    </article>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="pl-spacer pl-spacer--out--large pl-spacer--cut-h">
      <h2 class="text-center pl-h2 pl-push pl-push--mobile--smaller pl-push--tablet--smaller pl-push--desktop--smaller">最新资讯</h2>
      <div class="container">
        <div id="pl-homepage-content"
             class="pl-tabs">
          <div class="pl-tabs__wrap"></div>
          <div class="row">
            <div id="featured"
                 class="pl-tabs__tab active">
              <div class="grid_show">
                <div style="padding:0 30px"
                     v-for="(home_article, index) in content.articles"
                     v-bind:key="index"
                     class="col-xs-12 col-md-3 grid-item pl-push pl-push--mobile--smaller pl-push--tablet--smaller pl-push--desktop--smaller">
                  <article>
                    <div class="pl-push pl-push--mobile--smallest pl-push--tablet--smallest pl-push--desktop--smallest pl-relative">
                      <a class="pl-amplience--overflow"
                         v-bind:href="home_article.url"
                         target="_self"
                         data-Tealiumevent="generic">
                        <picture class="pl-amplience pl-amplience--scale">
                          <img v-bind:src="getImagePath(home_article.image)"
                               v-bind:alt="home_article.alt"
                               class="pl-amplience__image" />
                        </picture>
                      </a>
                      <div class="pl-spacer pl-spacer--in--smallest pl-fix pl-fix--mobile--top-right pl-fix--tablet--top-right pl-fix--desktop--top-right">
                      </div>
                    </div>

                    <div class="pl-lockup text-left">
                      <p class="pl-tag pl-tag--gray">{{ home_article.category }}</p>
                      <h4 class="pl-h4 pl-color pl-color--gray-darker">
                        <a v-bind:href="home_article.url"
                           target="_self">{{ home_article.title }}</a>
                      </h4>
                      <p class="pl-text pl-text--small pl-color pl-color--gray-dark">{{ home_article.subtitle }}</p>
                    </div>
                  </article>
                </div>
              </div>

              <div class="grid width_50">

                <div class="width_100 float_left">
                  <div style="padding:0 15px"
                       class="width_100 col-xs-12 col-md-3 grid-item pl-push pl-push--mobile--smaller pl-push--tablet--smaller pl-push--desktop--smaller">
                    <article>
                      <div class="pl-push pl-push--mobile--smallest pl-push--tablet--smallest pl-push--desktop--smallest pl-relative">
                        <a class="pl-amplience--overflow"
                           v-bind:href="firstBigArticle.url"
                           target="_self"
                           data-Tealiumevent="generic">
                          <picture class="pl-amplience pl-amplience--scale">
                            <img v-bind:src="getImagePath(firstBigArticle.image)"
                                 v-bind:alt="firstBigArticle.alt"
                                 class="pl-amplience__image" />
                          </picture>
                        </a>
                        <div class="pl-spacer pl-spacer--in--smallest pl-fix pl-fix--mobile--top-right pl-fix--tablet--top-right pl-fix--desktop--top-right">
                        </div>
                      </div>

                      <div class="pl-lockup text-left">
                        <p class="pl-tag pl-tag--gray">{{ firstBigArticle.category }}</p>
                        <h4 class="pl-h4 pl-color pl-color--gray-darker">
                          <a v-bind:href="firstBigArticle.url"
                             target="_self">{{ firstBigArticle.title }}</a>
                        </h4>
                        <p class="pl-text pl-text--small pl-color pl-color--gray-dark">{{ firstBigArticle.subtitle }}</p>
                      </div>
                    </article>
                  </div>
                </div>

                <div class="width_50 float_left">
                  <div style="padding:0 15px"
                       v-for="(home_article, index) in this.firstColum"
                       v-bind:key="index"
                       class="width_100 col-xs-12 col-md-3 grid-item pl-push pl-push--mobile--smaller pl-push--tablet--smaller pl-push--desktop--smaller">
                    <article>
                      <div class="pl-push pl-push--mobile--smallest pl-push--tablet--smallest pl-push--desktop--smallest pl-relative">
                        <a class="pl-amplience--overflow"
                           v-bind:href="home_article.url"
                           target="_self"
                           data-Tealiumevent="generic">
                          <picture class="pl-amplience pl-amplience--scale">
                            <img v-bind:src="getImagePath(home_article.image)"
                                 v-bind:alt="home_article.alt"
                                 class="pl-amplience__image" />
                          </picture>
                        </a>
                        <div class="pl-spacer pl-spacer--in--smallest pl-fix pl-fix--mobile--top-right pl-fix--tablet--top-right pl-fix--desktop--top-right">
                        </div>
                      </div>

                      <div class="pl-lockup text-left">
                        <p class="pl-tag pl-tag--gray">{{ home_article.category }}</p>
                        <h4 class="pl-h4 pl-color pl-color--gray-darker">
                          <a v-bind:href="home_article.url"
                             target="_self">{{ home_article.title }}</a>
                        </h4>
                        <p class="pl-text pl-text--small pl-color pl-color--gray-dark">{{ home_article.subtitle }}</p>
                      </div>
                    </article>
                  </div>
                </div>
                <div class="width_50 float_left">
                  <div style="padding:0 15px"
                       v-for="(home_article, index) in this.secondColum"
                       v-bind:key="index"
                       class="width_100 col-xs-12 col-md-3 grid-item pl-push pl-push--mobile--smaller pl-push--tablet--smaller pl-push--desktop--smaller">
                    <article>
                      <div class="pl-push pl-push--mobile--smallest pl-push--tablet--smallest pl-push--desktop--smallest pl-relative">
                        <a class="pl-amplience--overflow"
                           v-bind:href="home_article.url"
                           target="_self"
                           data-Tealiumevent="generic">
                          <picture class="pl-amplience pl-amplience--scale">
                            <img v-bind:src="getImagePath(home_article.image)"
                                 v-bind:alt="home_article.alt"
                                 class="pl-amplience__image" />
                          </picture>
                        </a>
                        <div class="pl-spacer pl-spacer--in--smallest pl-fix pl-fix--mobile--top-right pl-fix--tablet--top-right pl-fix--desktop--top-right">
                        </div>
                      </div>

                      <div class="pl-lockup text-left">
                        <p class="pl-tag pl-tag--gray">{{ home_article.category }}</p>
                        <h4 class="pl-h4 pl-color pl-color--gray-darker">
                          <a v-bind:href="home_article.url"
                             target="_self">{{ home_article.title }}</a>
                        </h4>
                        <p class="pl-text pl-text--small pl-color pl-color--gray-dark">{{ home_article.subtitle }}</p>
                      </div>
                    </article>
                  </div>
                </div>
              </div>

              <div class="grid width_50">

                <div class="width_100 float_left">
                  <div style="padding:0 15px"
                       class="width_100 col-xs-12 col-md-3 grid-item pl-push pl-push--mobile--smaller pl-push--tablet--smaller pl-push--desktop--smaller">
                    <article>
                      <div class="pl-push pl-push--mobile--smallest pl-push--tablet--smallest pl-push--desktop--smallest pl-relative">
                        <a class="pl-amplience--overflow"
                           v-bind:href="secondBigArticle.url"
                           target="_self"
                           data-Tealiumevent="generic">
                          <picture class="pl-amplience pl-amplience--scale">
                            <img v-bind:src="getImagePath(secondBigArticle.image)"
                                 v-bind:alt="secondBigArticle.alt"
                                 class="pl-amplience__image" />
                          </picture>
                        </a>
                        <div class="pl-spacer pl-spacer--in--smallest pl-fix pl-fix--mobile--top-right pl-fix--tablet--top-right pl-fix--desktop--top-right">
                        </div>
                      </div>

                      <div class="pl-lockup text-left">
                        <p class="pl-tag pl-tag--gray">{{ secondBigArticle.category }}</p>
                        <h4 class="pl-h4 pl-color pl-color--gray-darker">
                          <a v-bind:href="secondBigArticle.url"
                             target="_self">{{ secondBigArticle.title }}</a>
                        </h4>
                        <p class="pl-text pl-text--small pl-color pl-color--gray-dark">{{ secondBigArticle.subtitle }}</p>
                      </div>
                    </article>
                  </div>
                </div>

                <div class="width_50 float_left">
                  <div style="padding:0 15px"
                       v-for="(home_article, index) in this.thirdColum"
                       v-bind:key="index"
                       class="width_100 col-xs-12 col-md-3 grid-item pl-push pl-push--mobile--smaller pl-push--tablet--smaller pl-push--desktop--smaller">
                    <article>
                      <div class="pl-push pl-push--mobile--smallest pl-push--tablet--smallest pl-push--desktop--smallest pl-relative">
                        <a class="pl-amplience--overflow"
                           v-bind:href="home_article.url"
                           target="_self"
                           data-Tealiumevent="generic">
                          <picture class="pl-amplience pl-amplience--scale">
                            <img v-bind:src="getImagePath(home_article.image)"
                                 v-bind:alt="home_article.alt"
                                 class="pl-amplience__image" />
                          </picture>
                        </a>
                        <div class="pl-spacer pl-spacer--in--smallest pl-fix pl-fix--mobile--top-right pl-fix--tablet--top-right pl-fix--desktop--top-right">
                        </div>
                      </div>

                      <div class="pl-lockup text-left">
                        <p class="pl-tag pl-tag--gray">{{ home_article.category }}</p>
                        <h4 class="pl-h4 pl-color pl-color--gray-darker">
                          <a v-bind:href="home_article.url"
                             target="_self">{{ home_article.title }}</a>
                        </h4>
                        <p class="pl-text pl-text--small pl-color pl-color--gray-dark">{{ home_article.subtitle }}</p>
                      </div>
                    </article>
                  </div>
                </div>
                <div class="width_50 float_left">
                  <div style="padding:0 15px"
                       v-for="(home_article, index) in this.forthColum"
                       v-bind:key="index"
                       class="width_100 col-xs-12 col-md-3 grid-item pl-push pl-push--mobile--smaller pl-push--tablet--smaller pl-push--desktop--smaller">
                    <article>
                      <div class="pl-push pl-push--mobile--smallest pl-push--tablet--smallest pl-push--desktop--smallest pl-relative">
                        <a class="pl-amplience--overflow"
                           v-bind:href="home_article.url"
                           target="_self"
                           data-Tealiumevent="generic">
                          <picture class="pl-amplience pl-amplience--scale">
                            <img v-bind:src="getImagePath(home_article.image)"
                                 v-bind:alt="home_article.alt"
                                 class="pl-amplience__image" />
                          </picture>
                        </a>
                        <div class="pl-spacer pl-spacer--in--smallest pl-fix pl-fix--mobile--top-right pl-fix--tablet--top-right pl-fix--desktop--top-right">
                        </div>
                      </div>

                      <div class="pl-lockup text-left">
                        <p class="pl-tag pl-tag--gray">{{ home_article.category }}</p>
                        <h4 class="pl-h4 pl-color pl-color--gray-darker">
                          <a v-bind:href="home_article.url"
                             target="_self">{{ home_article.title }}</a>
                        </h4>
                        <p class="pl-text pl-text--small pl-color pl-color--gray-dark">{{ home_article.subtitle }}</p>
                      </div>
                    </article>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <section class="pl-spacer pl-spacer--out--large pl-spacer--cut-h">
      <h2 class="text-center pl-h2 pl-push pl-push--mobile--smaller pl-push--tablet--smaller pl-push--desktop--smaller">最新资讯</h2>
      <div class="container">
        <div id="pl-homepage-content"
             class="pl-tabs">
          <div class="pl-tabs__wrap"></div>
          <!-- TODO: -->
          <div class="row">
            <div id="featured"
                 class="pl-tabs__tab active">
              <div class="grid_show">
                <div style="padding:0 30px"
                     v-for="(home_article, index) in content.articles"
                     v-bind:key="index"
                     class="col-xs-12 col-md-3 grid-item pl-push pl-push--mobile--smaller pl-push--tablet--smaller pl-push--desktop--smaller margin-bottom">
                  <article>
                    <div class="pl-push pl-push--mobile--smallest pl-push--tablet--smallest pl-push--desktop--smallest pl-relative">
                      <a class="pl-amplience--overflow"
                         v-bind:href="home_article.url"
                         target="_self"
                         data-Tealiumevent="generic">
                        <picture class="pl-amplience pl-amplience--scale">
                          <img v-bind:src="getImagePath(home_article.image)"
                               v-bind:alt="home_article.alt"
                               class="pl-amplience__image" />
                        </picture>
                      </a>
                      <div class="pl-spacer pl-spacer--in--smallest pl-fix pl-fix--mobile--top-right pl-fix--tablet--top-right pl-fix--desktop--top-right">
                      </div>
                    </div>

                    <div class="pl-lockup text-left">
                      <p class="pl-tag pl-tag--gray">{{ home_article.category }}</p>
                      <h4 class="pl-h4 pl-color pl-color--gray-darker">
                        <a v-bind:href="home_article.url"
                           target="_self">{{ home_article.title }}</a>
                      </h4>
                      <p class="pl-text pl-text--small pl-color pl-color--gray-dark">{{ home_article.subtitle }}</p>
                    </div>
                  </article>
                </div>
              </div>

              <div class="grid width_100">

                <div class="width_100 flex">
                  <div style="padding:0 15px"
                       :style="{'padding-bottom': index<2? '20px':''}"
                       v-for="(home_article, index) in this.content.articles"
                       v-bind:key="index"
                       :class="index<2? 'width_50':'width_25'"
                       class="col-xs-12 col-md-3 grid-item pl-push pl-push--mobile--smaller pl-push--tablet--smaller pl-push--desktop--smaller">
                    <article>
                      <div class="pl-push pl-push--mobile--smallest pl-push--tablet--smallest pl-push--desktop--smallest pl-relative">
                        <a class="pl-amplience--overflow"
                           v-bind:href="home_article.url"
                           target="_self"
                           data-Tealiumevent="generic">
                          <picture class="pl-amplience pl-amplience--scale">
                            <img v-bind:src="getImagePath(home_article.image)"
                                 v-bind:alt="home_article.alt"
                                 class="pl-amplience__image" />
                          </picture>
                        </a>
                        <div class="pl-spacer pl-spacer--in--smallest pl-fix pl-fix--mobile--top-right pl-fix--tablet--top-right pl-fix--desktop--top-right">
                        </div>
                      </div>

                      <div class="pl-lockup text-left">
                        <p class="pl-tag pl-tag--gray">{{ home_article.category }}</p>
                        <h4 class="pl-h4 pl-color pl-color--gray-darker">
                          <a v-bind:href="home_article.url"
                             target="_self">{{ home_article.title }}</a>
                        </h4>
                        <p class="pl-text pl-text--small pl-color pl-color--gray-dark">{{ home_article.subtitle }}</p>
                      </div>
                    </article>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="bottom_button_section">
      <div class="text_align">
        <h2 class="">{{content.contact_text}}</h2>
        <br>
        <a href="mailto:enquiry@cbsg.canon.com.cn"
           class="pl-btn--medium">{{content.contact_button}}</a>
      </div>
    </section> -->

    <learnmore :option="learn_option">
      <template slot="line_one">{{content.contact_text1}}</template>
      <template slot="line_two">{{content.contact_text2}}</template>
      <template slot="learn_more_button">{{content.contact_button}}</template>
    </learnmore>

  </div>
</template>

<script>
import contents from '../json/contents.json'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import learnmore from './LearnMore'
export default {
  name: 'Home',
  components: {
    swiper,
    swiperSlide,
    learnmore
  },

  props: [
    'belongTo'
  ],

  data () {
    return {
      content: '',
      firstColumContent: [],
      secondColumContent: [],
      thirdColumContent: [],
      firstBigArticle: {},
      secondBigArticle: {},
      firstColum: [],
      secondColum: [],
      thirdColum: [],
      forthColum: [],
      swiperOption: {
        slideToClickedSlide: true,
        slidesPerView: 1,
        autoplay: true,
        delay: 5000,
        pagination: {
          clickable: true,
          el: '.swiper-pagination'
        }
      },
      learn_option: {
        backgroundColor: '#323232',
        fontColor: '#ffffff'
      }

    }
  },

  methods: {
    getImagePath (name) {
      var images = require.context('../assets/FFP/images/', true, /\.png$/)
      console.log(images('./banner.png'))
      return name ? images(name) : ''
    },
    divideColum (articleArr) {
      for (let i = 0; i < articleArr.length; i++) {
        if (i < 4) {
          this.firstColumContent.push(articleArr[i])
        } else if (i % 2 === 0) {
          this.secondColumContent.push(articleArr[i])
        } else {
          this.thirdColumContent.push(articleArr[i])
        }
      }
    },
    divideFourColum (articleArr) {
      console.log(articleArr.length)
      this.firstBigArticle = articleArr[0]
      let halfLength = parseInt(articleArr.length / 2)
      if (articleArr.length % 2 === 1) {
        halfLength = halfLength + 1
      }
      console.log(halfLength)
      this.secondBigArticle = articleArr[halfLength]
      for (let i = 1; i < halfLength; i++) {
        if (i % 2 === 0) {
          this.secondColum.push(articleArr[i])
        } else {
          this.firstColum.push(articleArr[i])
        }
      }
      for (let i = halfLength + 1; i < articleArr.length; i++) {
        if (i % 2 === 0) {
          this.forthColum.push(articleArr[i])
        } else {
          this.thirdColum.push(articleArr[i])
        }
      }
    }
  },

  mounted () {
    var page = this.belongTo + '_home'
    console.log('Page: ' + this.belongTo)
    this.content = contents[page]
    this.divideColum(this.content.articles)
    this.divideFourColum(this.content.articles)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='../assets/FFP/css/Home.css'></style>



// WEBPACK FOOTER //
// src/components/Home.vue